<template>
  <div>
    <Header />
    <section
      id="comparer_form"
      class="px-4 pt-16 pb-32 overflow-hidden bg-gray-100"
    >
      <div class="max-w-6xl mx-auto">
        <div class="font-bold text-sm mb-16" :class="$store.state.isInIframe ? 'text-xs' : 'text-sm'">
          Ministerstwo Spraw Zagranicznych wprowadziło najwyższy poziom
          ostrzeżenia dla podróżujących po terytorium <span class="text-red-100">Izraela</span> i
          odradza jakiekolwiek podróże do tego kraju. <br />

          W związku z tym
          <span class="text-red-100"
            >Towarzystwa Ubezpieczeń czasowo wycofują Izrael z listy państw
            objętych ubezpieczeniem turystycznym.</span
          >
        </div>
        <Form />
      </div>
    </section>
  </div>
</template>

<script>
import Form from './components/Form.vue'
import Header from './components/Header.vue'

export default {
  components: {
    Form,
    Header
  },
  data () {
    return {
      services: ''
    }
  },

  mounted () {
    this.$store.commit('setStep', 1)
    window.scrollTo(0, 0)
  }
}
</script>
